<template>
  <fragment>
    <AppBody title="Operações" subtitle="Equipamentos / Cadastrar - Editar">
      <div class="search-forms">
        <v-row class="mb-5">
          <v-col cols="12" sm="4">
            <label required class="input-labels"> Tipo de Equipamento </label>
            <v-select
              height="48"
              :items="tipo_equipamento"
              dense
              solo
              class="textinput"
              item-text="text"
              item-value="value"
              v-model="$operacoes_equipamentos.cadastro.tipo_equipamento"
              placeholder="Selecione o tipo"
              :color="$config.dados.corinputs"
              :item-color="$config.dados.corinputs"
              :error-messages="
                $operacoes_equipamentos.cadastro.error.tipo_equipamento
              "
              @input="
                $operacoes_equipamentos.cadastro.error.tipo_equipamento = []
              "
            ></v-select>
          </v-col>

          <v-col cols="12" sm="4">
            <label required class="input-labels"> Status </label>
            <v-select
              height="48"
              :items="status"
              dense
              solo
              class="textinput"
              item-text="text"
              item-value="value"
              v-model="$operacoes_equipamentos.cadastro.status"
              placeholder="Selecione o status"
              :color="$config.dados.corinputs"
              :item-color="$config.dados.corinputs"
              :error-messages="$operacoes_equipamentos.cadastro.error.status"
              @input="$operacoes_equipamentos.cadastro.error.status = []"
            ></v-select>
          </v-col>
          <v-col
            v-if="$operacoes_equipamentos.cadastro.tipo_equipamento === 'POS'"
            cols="12"
            sm="4"
          >
            <label required class="input-labels">Ponto de venda (POS)</label>
            <v-autocomplete
              v-model="$operacoes_equipamentos.cadastro.point_sale"
              :items="orderedData"
              solo
              class="textinput"
              placeholder="Selecione um POS para vincular"
              chip
              deletable-chips
              clear-icon="mdi-close-circle-outline"
              :color="$config.dados.corinputs"
              :item-color="$config.dados.corinputs"
              :error-messages="
                $operacoes_equipamentos.cadastro.error.point_sale
              "
              :loading="$pointOfSale.loading"
              @input="$operacoes_equipamentos.cadastro.error.point_sale = []"
              item-text="representante_nome"
              item-value="idponto_venda"
              no-data-text="Nenhum ponto de venda encontrado"
              return-object
            >
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row
          v-if="$operacoes_equipamentos.cadastro.tipo_equipamento === 'POS'"
        >
          <v-col cols="12" sm="4">
            <label required class="input-labels"> Descrição </label>
            <v-text-field
              solo
              placeholder="Insira a descrição"
              v-model="$operacoes_equipamentos.cadastro.descricao"
              type="text"
              class="textinput"
              :error-messages="$operacoes_equipamentos.cadastro.error.descricao"
              @input="$operacoes_equipamentos.cadastro.error.descricao = []"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <label required class="input-labels"> Número de Série </label>
            <v-text-field
              solo
              placeholder="insira o nº de série"
              v-model="$operacoes_equipamentos.cadastro.numero_serie"
              type="text"
              class="textinput"
              :error-messages="
                $operacoes_equipamentos.cadastro.error.numero_serie
              "
              @input="$operacoes_equipamentos.cadastro.error.numero_serie = []"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <label required class="input-labels"> Tipo de Rede </label>
            <v-select
              height="48"
              :items="rede_vendas_itens"
              dense
              solo
              class="textinput"
              item-text="text"
              item-value="value"
              readonly
              v-model="$operacoes_equipamentos.cadastro.rede_vendas"
              placeholder="Selecione o tipo da rede de vendas"
              :color="$config.dados.corinputs"
              :item-color="$config.dados.corinputs"
              :error-messages="
                $operacoes_equipamentos.cadastro.error.rede_vendas
              "
              :loading="$pointOfSale.loading"
              @input="$operacoes_equipamentos.cadastro.error.rede_vendas = []"
            ></v-select>
          </v-col>
        </v-row>
        <v-row
          v-if="$operacoes_equipamentos.cadastro.tipo_equipamento === 'POS'"
        >
          <v-col cols="12" sm="4">
            <label required class="input-labels">{{ getLabelStore() }}</label>
            <v-autocomplete
              v-model="$operacoes_equipamentos.cadastro.lojas"
              :items="$loja_gerenciar.lojas"
              solo
              class="textinput"
              :placeholder="getPlaceholderStore()"
              :multiple="isMultiple"
              chip
              :readonly="isPointSalePrivate"
              deletable-chips
              clear-icon="mdi-close-circle-outline"
              :color="$config.dados.corinputs"
              :item-color="$config.dados.corinputs"
              :error-messages="$operacoes_equipamentos.cadastro.error.lojas"
              @input="$operacoes_equipamentos.cadastro.error.lojas = []"
              item-text="nome_loja"
              item-value="sequenciador"
              :loading="$loja_gerenciar.cadastro.lojas_loading"
              no-data-text="Nenhuma loja encontrada"
            >
              <template v-slot:selection="{ item }">
                <v-chip
                  :close="isMultiple"
                  @click:close="removeStoreItem(item)"
                  >{{ item.nome_loja }}</v-chip
                >
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4">
            <label class="input-labels"> Eventos </label>
            <v-autocomplete
              v-model="$operacoes_equipamentos.cadastro.events"
              :items="this.allEvents"
              solo
              class="textinput"
              placeholder="Selecione os eventos"
              multiple
              chip
              deletable-chips
              clear-icon="mdi-close-circle-outline"
              :color="$config.dados.corinputs"
              :item-color="$config.dados.corinputs"
              :error-messages="$operacoes_equipamentos.cadastro.error.events"
              @input="$operacoes_equipamentos.cadastro.error.events = []"
              item-text="descricao"
              item-value="idproduto"
              return-object
              :loading="$operacoes_equipamentos.cadastro.loading"
              :filter="searchEvents"
              no-data-text="Nenhum produto encontrado"
            >
              <template v-slot:selection="{ item }">
                <v-chip close @click:close="removeEventItem(item)">{{
                  item.descricao
                }}</v-chip>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4">
            <label class="input-labels"> Data de Ativação </label>
            <v-text-field
              v-model="$operacoes_equipamentos.cadastro.data_ativacao"
              type="datetime"
              class="textinput"
              v-mask="['XX/XX/XXXX']"
              placeholder="dd/mm/aaaa"
              hide-details
              solo
              append-icon="mdi-calendar-blank-outline"
              :error-messages="
                $operacoes_equipamentos.cadastro.error.data_ativacao
              "
              @input="$operacoes_equipamentos.cadastro.error.data_ativacao = []"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-col
          v-if="$operacoes_equipamentos.cadastro.tipo_equipamento === 'POS'"
          cols="12"
        >
          <div class="able-fees-container02 secondary">
            <div class="able-fees-container03">
              <v-checkbox
                label="Aplicar Taxa de Conveniência/Comissão"
                v-model="$operacoes_equipamentos.cadastro.aplicar_taxa"
              >
              </v-checkbox>
            </div>
          </div>
        </v-col>

        <template
          v-if="$operacoes_equipamentos.cadastro.tipo_equipamento === 'PDV'"
        >
          <v-row>
            <v-col cols="12">
              <v-row>
                <h1 class="dados-ponto-venda-subtitle pl-3">
                  Dados do ponto de venda
                </h1>
                <h1 class="dados-ponto-venda-subtitle2 pl-2">
                  (para habilitar as opções abaixo, realize o vínculo deste
                  equipamento ao ponto de venda)
                </h1>
              </v-row>
              <v-row>
                <v-divider class="ml-3 mr-3"> </v-divider>
              </v-row>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="5" md="6">
              <label required class="input-labels"> Link de vendas </label>
              <v-text-field
                :disabled="true"
                class="textinput"
                solo
                placeholder="Link de vendas"
                v-model="$operacoes_equipamentos.cadastro.link_vendas"
                height="48"
                type="text"
                :error-messages="
                  $operacoes_equipamentos.cadastro.error.link_vendas
                "
                @input="$operacoes_equipamentos.cadastro.error.link_vendas = []"
              >
              </v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="7"
              md="6"
              class="d-flex flex-sm-row flex-column align-sm-end"
            >
              <v-btn
                height="48"
                class="button btn-border mr-sm-2"
                @click="copyText"
                :disabled="$operacoes_equipamentos.cadastro.idpdv_empty"
              >
                <v-icon
                  >{{ copyLink ? "mdi-content-copy" : "mdi-check" }}
                </v-icon>
              </v-btn>
              <v-btn
                height="48"
                class="button btn-border mr-sm-2 mt-sm-0 mt-2"
                @click="
                  $operacoes_equipamentos.generateLink(
                    $operacoes_equipamentos.cadastro.idponto_venda,
                    $operacoes_equipamentos.cadastro.idequipamento
                  )
                "
                :disabled="$operacoes_equipamentos.cadastro.idpdv_empty"
              >
                Gerar link
              </v-btn>
              <v-btn
                height="48"
                class="button btn-border mt-sm-0 mt-2"
                @click="$operacoes_equipamentos.generateQRCode()"
                :disabled="geraQrcodeIsEmpty"
              >
                Gerar QRCode
              </v-btn>
            </v-col>
          </v-row>

          <v-row no-gutters class="pl-2">
            <v-checkbox
              :disabled="$operacoes_equipamentos.cadastro.idpdv_empty"
              label="Exibir equipamento no aplicativo do ponto de venda."
              v-model="$operacoes_equipamentos.cadastro.is_app"
              :true-value="1"
              :false-value="0"
              :items="$operacoes_equipamentos.equipamentos"
              item-value="idponto_venda"
            >
            </v-checkbox>
          </v-row>
        </template>
      </div>
      <RegistrationActions
        :loader="$operacoes_equipamentos.cadastro.loading"
        :actions="actions"
      />
    </AppBody>
  </fragment>
</template>

<script>
import { displayHelpers } from "@/mixins/breakpoints.mixins";
import { mapGetters, mapActions } from "vuex";
import _ from "lodash";
export default {
  name: "EquipmentsSettings",
  mixins: [displayHelpers],
  metaInfo: {
    title: "Equipamentos | Adicionar/Editar | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Equipamentos | Adicionar/Editar | ElevenTickets",
      },
    ],
  },
  components: {
    AppBody: () => import("@/layouts/components/AppBody.vue"),
    RegistrationActions: () =>
      import("@/components/global/RegistrationActions.vue"),
  },
  data() {
    return {
      actions: [
        {
          name: "Salvar",
          action: () => this.$operacoes_equipamentos.validarCadastro(),
        },
        {
          name: "Cancelar",
          action: () => this.cancelAction(),
        },
      ],
      tipo_equipamento: [
        {
          text: "POS",
          value: "POS",
        },
        {
          text: "QR CODE",
          value: "PDV",
        },
      ],
      status: [
        {
          text: "ATIVO",
          value: "ATIVO",
        },
        {
          text: "INATIVO",
          value: "INATIVO",
        },
      ],
      rede_vendas_itens: [
        { text: "COMPARTILHADA", value: "COMPARTILHADA" },
        { text: "PRIVADA", value: "PRIVADA" },
      ],
      copyLink: true,
    };
  },
  computed: {
    ...mapGetters(["allEvents"]),
    orderedData() {
      return _.orderBy(
        this.$pointOfSale.pontos_de_venda,
        ["status", "cadastro"],
        ["asc", "desc"]
      );
    },
    isPointSalePrivate() {
      return (
        this.$operacoes_equipamentos.cadastro?.point_sale?.rede_vendas ===
        "PRIVADA"
      );
    },
    isMultiple() {
      return (
        this.$operacoes_equipamentos.cadastro?.rede_vendas === "COMPARTILHADA"
      );
    },
    geraQrcodeIsEmpty: {
      get() {
        if (
          this.$operacoes_equipamentos.cadastro.link_vendas === null ||
          this.$operacoes_equipamentos.cadastro.link_vendas === undefined ||
          this.$operacoes_equipamentos.cadastro.link_vendas === ""
        ) {
          return true;
        }
        return false;
      },
      set() {},
    },
  },
  methods: {
    ...mapActions(["fetchEvents", "fetchEventsOfAnyStore"]),
    filterSelectedPointOfSale() {
      if (
        typeof this.$operacoes_equipamentos.cadastro.point_sale === "string"
      ) {
        const filteredPointOfSale = this.$pointOfSale.pontos_de_venda.filter(
          item =>
            item.idponto_venda ===
            this.$operacoes_equipamentos.cadastro.point_sale
        );
        this.$operacoes_equipamentos.cadastro.point_sale =
          filteredPointOfSale[0];
      } else {
        return;
      }
    },
    filterSelectedEvents() {
      if (Array.isArray(this.$operacoes_equipamentos.cadastro.events)) {
        const hasStrings = this.$operacoes_equipamentos.cadastro.events.some(
          event => typeof event === "string"
        );

        if (hasStrings) {
          const filteredEvents = this.allEvents.filter(item =>
            this.$operacoes_equipamentos.cadastro.events.includes(
              item.idproduto
            )
          );
          this.$operacoes_equipamentos.cadastro.events = filteredEvents;
        }
      }
    },

    searchEvents(item, queryText, itemText) {
      const normalizedQuery = this.replaceSpecialChars(
        queryText
          .toString()
          .toLocaleLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
      );
      const normalizedItem = this.replaceSpecialChars(
        itemText
          .toString()
          .toLocaleLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
      );

      return normalizedItem.includes(normalizedQuery);
    },
    replaceSpecialChars(str) {
      return str;
    },
    getLabelStore() {
      return this.$operacoes_equipamentos.cadastro?.rede_vendas ===
        "COMPARTILHADA"
        ? "Lojas"
        : "Loja";
    },
    getPlaceholderStore() {
      return this.$operacoes_equipamentos.cadastro?.rede_vendas ===
        "COMPARTILHADA"
        ? "Selecione as lojas"
        : "Selecione a loja";
    },
    removeStoreItem(item) {
      this.$operacoes_equipamentos.cadastro.lojas =
        this.$operacoes_equipamentos.cadastro.lojas.filter(
          loja => loja !== item.sequenciador
        );
    },
    removeEventItem(item) {
      this.$operacoes_equipamentos.cadastro.events =
        this.$operacoes_equipamentos.cadastro.events.filter(
          event => event.idproduto !== item.idproduto
        );
    },
    cancelAction() {
      this.$router.push({
        name: "equipments",
      });
    },
    copyText() {
      navigator.clipboard.writeText(
        this.$operacoes_equipamentos.cadastro.link_vendas
      );
      this.$config.alert(
        "Link de vendas copiado!",
        this.$config.dados.successColor
      );
      this.copyLink = false;
    },
  },
  destroyed() {
    this.$operacoes_equipamentos.limparFormularioEquipamento();
  },
  mounted() {
    this.$pointOfSale.getPointsOfSale();
    this.$loja_gerenciar.getAllLojas();
  },
  watch: {
    "$operacoes_equipamentos.cadastro.point_sale"(e) {
      this.filterSelectedEvents();
      this.$operacoes_equipamentos.cadastro.rede_vendas = e
        ? e.rede_vendas
        : "";
      if (
        e &&
        e.loja !== null &&
        (!Array.isArray(e.loja) || e.loja[0] !== null)
      ) {
        this.$operacoes_equipamentos.cadastro.lojas =
          e && e.rede_vendas === "COMPARTILHADA" ? [e.loja] : e.loja;
      }
    },
    "$pointOfSale.pontos_de_venda"() {
      this.filterSelectedPointOfSale();
    },
    "this.allEvents"() {
      this.filterSelectedEvents();
    },
    "$operacoes_equipamentos.cadastro.lojas"(newVal) {
      this.filterSelectedEvents();
      if (
        !newVal ||
        (Array.isArray(newVal) && newVal.length === 1 && newVal[0] === null)
      ) {
        return;
      }

      if (
        newVal.length > 0 ||
        newVal !== null ||
        newVal !== undefined ||
        newVal !== ""
      ) {
        const { cadastro } = this.$operacoes_equipamentos;

        if (cadastro.point_sale.rede_vendas === "COMPARTILHADA") {
          this.fetchEventsOfAnyStore({
            producers: newVal,
            filtro: [],
          });
        } else {
          this.fetchEvents({
            producerId: newVal,
            filtro: [],
          });
        }
      }
    },
  },
};
</script>

<style scoped>
.teste {
  display: flex;
  flex-wrap: wrap;
}
.able-fees-container02 {
  flex: 0 0 auto;
  display: flex;
  width: 100%;
  height: 50px;
  align-items: center;
  border-radius: 20px;
  flex-direction: row;
  justify-content: flex-end;
  background-color: #c9c9c9;
  margin-top: 23px;
}
.able-fees-container03 {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-end;
  padding: 10px 15px 10px 15px;
}
.equip-app-container {
  width: 49.5%;
  height: 68%;
  display: flex;
  align-items: center;
  border-radius: 10px;
  flex-direction: row;
  justify-content: center;
  background-color: #c9c9c9;
}

.dados-ponto-venda-subtitle {
  width: auto;
  font-size: 1rem;
  align-self: flex-;
}

.dados-ponto-venda-subtitle2 {
  width: auto;
  font-size: 1rem;
  align-self: flex-;
  color: #aaa5a5;
}
</style>
